import type { ThemeRegistry } from '@classy/theme-sdk';

// Themes hidden from the default/public set. They only appear when explicitly
// unlocked — per-org (redeemer, via the admin theme controls) or per-teacher
// (sarah, via PERSONAL_THEME_KEYS below).
export const SCHOOL_SPECIFIC_THEME_KEYS = new Set(['redeemer', 'sarah']);

/**
 * Private themes unlocked for a single teacher's sign-in email (lowercased),
 * added on top of the org/public themes so they show even when the org's
 * enabledThemeKeys allowlist doesn't include them. Hidden from everyone else.
 */
const PERSONAL_THEME_KEYS: Record<string, readonly string[]> = {
  'sarah@sm2gk.com': ['sarah'],
  'dev@classy.local': ['sarah'], // dev-auth account, for local testing only
};

export function publicThemeKeys(registry: ThemeRegistry): string[] {
  return registry
    .list()
    .filter((theme) => !SCHOOL_SPECIFIC_THEME_KEYS.has(theme.key))
    .map((theme) => theme.key);
}

/** Extra theme keys this teacher may use on top of the org/public set. */
export function personalThemeKeys(email: string | undefined | null): readonly string[] {
  if (!email) return [];
  return PERSONAL_THEME_KEYS[email.trim().toLowerCase()] ?? [];
}
